import { Component, input } from '@angular/core';

import { RegisterComponent } from '../../components/component-lookup';

@RegisterComponent('TextBox')
@Component({
  selector: 'app-text-box',
  standalone: true,
  imports: [],
  templateUrl: './text-box.component.html',
  styleUrl: './text-box.component.scss'
})
export class TextBoxComponent {
  body = input.required<string>();
  tourId = input<string>();
}
